"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArtifactQuerySchema = exports.ArtifactListResponseSchema = exports.ArtifactObjectSchema = void 0;
const zod_1 = require("zod");
const workflow_1 = require("../workflow");
const list_1 = require("../list");
function ArtifactBaseSchema(type, data) {
    return zod_1.z.object({
        id: zod_1.z.string(),
        object: zod_1.z.literal('artifact'),
        type: zod_1.z.literal(type),
        data,
        created_at: zod_1.z.date().openapi({ format: 'date-time' }),
    });
}
// Object
exports.ArtifactObjectSchema = zod_1.z.discriminatedUnion('type', [
    ArtifactBaseSchema('submission', workflow_1.WorkflowTastSubmissionArtifactPayloadSchema),
]);
exports.ArtifactListResponseSchema = (0, list_1.ListResponseSchema)(exports.ArtifactObjectSchema, {
    title: 'ArtifactListResponse',
});
// Query
exports.ArtifactQuerySchema = zod_1.z
    .object({
    thread: zod_1.z.string(),
})
    .openapi('ArtifactQuery');
//# sourceMappingURL=artifactSchema.js.map